import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";

const asArray = (value) => (Array.isArray(value) ? value : []);

// Shared base for the "show affiliate link" detail-tab queries. Each endpoint
// responds with `{ data: { <dataKey>: [...] } }`. The query is only enabled
// while its tab is active, so nothing is fetched until that tab is opened;
// results stay cached afterwards (staleTime: Infinity).
export const useAffiliateLinkDetailQuery = ({
  queryKey,
  fetcher,
  id,
  dataKey,
  enabled,
}) =>
  useQuery({
    queryKey,
    queryFn: async () => {
      const { data } = await fetcher(id);
      return asArray(data?.[dataKey] ?? data);
    },
    enabled: !!id && !!enabled,
    ...reactQueryCacheAndRefetchOptions,
  });
